import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/avatar.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-121be5ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "content w-full bg-white" }
const _hoisted_3 = { class: "t-home__content p-4" }
const _hoisted_4 = { class: "t-home__content-wrapper d-flex" }
const _hoisted_5 = { class: "t-home__content-profile" }
const _hoisted_6 = { class: "d-flex flex-column" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "profile-picture",
  class: "profile-picture mb-2",
  src: _imports_0
}, null, -1))
const _hoisted_8 = {
  id: "tooltip-username",
  class: "text-primary-gc text-xl md:text-2.5xl text-center truncate mb-1"
}
const _hoisted_9 = {
  id: "tooltip-email",
  class: "text-dark-gray-gc text-xs md:text-sm text-center truncate"
}
const _hoisted_10 = { class: "t-home__content-test-list" }
const _hoisted_11 = {
  key: 0,
  class: "w-1/2 animate-pulse"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-14 bg-gray-200 rounded-md" }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "text-primary-gc text-xl md:text-2.5xl mb-1.5" }
const _hoisted_15 = { class: "text-dark-gray-gc text-xs md:text-sm" }
const _hoisted_16 = { class: "t-home__content-test-list__content mt-8 py-4 px-6" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "t-home__content-test-list__content-head" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "t-home__content-test-list__content-head-wrapper d-flex justify-content-between" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-primary-gc text-xl font-semibold text-center md:text-left" }, " Asesmen Kamu ")
  ])
], -1))
const _hoisted_18 = { class: "t-home__content-test-list__content-test" }
const _hoisted_19 = { class: "d-flex flex-column" }
const _hoisted_20 = {
  key: 0,
  class: "w-full animate-pulse"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-24 bg-gray-200 rounded-md mb-3" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-24 bg-gray-200 rounded-md mb-3" }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-24 bg-gray-200 rounded-md" }, null, -1))
const _hoisted_24 = [
  _hoisted_21,
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = { class: "t-home__content-test-list__content-test-item-wrapper d-flex" }
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "t-home__content-test-list__content-test-item-description d-flex flex-column" }
const _hoisted_28 = { class: "d-flex flex-column md:flex-row justify-between items-center my-4 md:my-0 md:mb-1.5 gap-y-1" }
const _hoisted_29 = { class: "text-primary-gc text-xl text-center md:text-left font-semibold" }
const _hoisted_30 = {
  key: 0,
  class: "text-secondary-gc text-sm"
}
const _hoisted_31 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GcHeader = _resolveComponent("GcHeader")!
  const _component_BButton = _resolveComponent("BButton")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_GcHeader, { "profile-data": _ctx.profileData }, null, 8, ["profile-data"])
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.profileData.name || "Name"), 1),
            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.profileData.email || "email"), 1),
            _createVNode(_component_BButton, {
              variant: "warning",
              class: "w-full text-sm font-semibold mt-2 md:mt-6",
              onClick: _ctx.goUpdateProfile
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Update Profil ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.detailProject.name), 1)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.detailProject.started_at) + " - " + _toDisplayString(_ctx.detailProject.ended_at), 1)
                ])
              ], 64)),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_24))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.listTest, (data) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: data.id,
                        class: "t-home__content-test-list__content-test-item"
                      }, [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("img", {
                            alt: "image-test",
                            class: "t-home__content-test-list__content-test-item-image",
                            src: data.image
                          }, null, 8, _hoisted_26),
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("p", _hoisted_29, [
                                _createTextVNode(_toDisplayString(data.name) + " ", 1),
                                _createVNode(_component_Badge, {
                                  variant: _ctx.getBadgeVariant(data.status).variant,
                                  label: _ctx.getBadgeVariant(data.status).text,
                                  "is-rounded-full": false,
                                  class: "hidden md:inline-block ml-0 md:ml-4"
                                }, null, 8, ["variant", "label"])
                              ]),
                              _createVNode(_component_Badge, {
                                variant: _ctx.getBadgeVariant(data.status).variant,
                                label: _ctx.getBadgeVariant(data.status).text,
                                "is-rounded-full": false,
                                class: "inline-block md:hidden"
                              }, null, 8, ["variant", "label"]),
                              (data.status === 'Done')
                                ? (_openBlock(), _createElementBlock("p", _hoisted_30, " Selesai pada " + _toDisplayString(data.user_bundle_result_created_at), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", {
                              innerHTML: data.description,
                              class: "text-dark-gray-gc text-sm text-justify"
                            }, null, 8, _hoisted_31),
                            (data.status !== 'Done')
                              ? (_openBlock(), _createBlock(_component_BButton, {
                                  key: 0,
                                  variant: "warning",
                                  class: "t-home__content-test-list__content-test-item-action text-center md:text-left text-sm font-semibold mt-4 py-2 md:px-8",
                                  onClick: ($event: any) => (_ctx.startAssesment(data.id))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(data.status === "Unopened"
                            ? "Mulai Assesmen"
                            : "Lanjutkan Assesmen") + " ", 1),
                                    _createVNode(_component_FontAwesomeIcon, {
                                      class: "ml-2",
                                      icon: "chevron-right"
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : (_openBlock(), _createBlock(_component_BButton, {
                                  key: 1,
                                  variant: "warning",
                                  class: "t-home__content-test-list__content-test-item-action text-left text-sm font-semibold mt-4 py-2 px-8",
                                  onClick: ($event: any) => (
                          _ctx.seeReport({
                            bundleId: data.id,
                            resultId: data.user_bundle_result_id,
                          })
                        )
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Baca Laporan "),
                                    _createVNode(_component_FontAwesomeIcon, {
                                      class: "ml-2",
                                      icon: "chevron-right"
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                          ])
                        ])
                      ]))
                    }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}